/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';
import { loadSelectPickerItems } from '../../../../app/common/store/select-picker.actions';
import { queryParamsMap } from '../../../../app/common/components/forms/select-picker/select-picker-types.enum';

const conversionsOperationTypes = [
  {
    value: 'insert',
    text: 'facebook-destination-editor.form.operation-type.option.insert',
    translate: true,
  },
];

const customersOperationTypes = [
  {
    value: 'insert',
    text: 'facebook-destination-editor.form.operation-type.option.insert',
    translate: true,
  },
  {
    value: 'replace',
    text: 'facebook-destination-editor.form.operation-type.option.replace',
    translate: true,
  },
  {
    value: 'delete',
    text: 'salesforce-destination-editor.form.operation-type.option.delete',
    translate: true,
  },
];

xplenty.directive('facebookDestinationEditor', [
  '$timeout',
  '$rootScope',
  '$translate',
  'selectPickerModal',
  function ($timeout, $rootScope, $translate, selectPickerModal) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./facebook-destination-editor.html'),

      replace: true,

      scope: false,

      controller: [
        '$scope',
        'ngrxStoreService',

        function ($scope, ngrxStoreService) {
          $scope.schemas = [];
          $scope.schemaReady = false;
          $scope.areFieldsLoading = false;
          $scope.schemaMappingStep.lock = true;
          $scope.records = angular.copy($scope.component.column_mappings);

          $scope.operationTypes = conversionsOperationTypes;

          $scope.onColumnMappingsChange = (records) => {
            $scope.component.column_mappings = records;
          };

          $scope.onUpdateConnection = ({ connectionType, type }) => {
            selectPickerModal.createNew(connectionType, type);

            const subscriber = $rootScope.$on(EVENTS.CONNECTION_UPDATED, () => {
              ngrxStoreService.dispatch(
                loadSelectPickerItems({
                  itemType: type,
                  params: { ...queryParamsMap[type], ...$scope.errorsOutputConnectionQuery },
                }),
              );
              subscriber();
            });
          };

          $scope.$watch('component.object_name', function (newVal) {
            if (newVal === 'Conversions') {
              $scope.operationTypes = conversionsOperationTypes;
            }
            if (newVal === 'Customers') {
              $scope.operationTypes = customersOperationTypes;
            }
          });

          $scope.onSchemaValidityChange = (isValid) => {
            $scope.collectionValid = isValid;

            const schemaMappingValid = $scope.collectionValid && !$scope.loadingFields;

            if (schemaMappingValid) {
              $scope.schemaMappingStep.tags = _.map($scope.records, function (record) {
                return {
                  name: _.escape(record.column_name),
                };
              });
            } else {
              $scope.schemaMappingStep.tags = [];
            }

            $scope.schemaMappingStep.error = !$scope.collectionValid;
            $scope.schemaMappingStep.valid = schemaMappingValid;

            return schemaMappingValid;
          };

          $scope.onOperationTypeChange = (operationType) => {
            $scope.component.operation_type = operationType;
          };

          $scope.$on(EVENTS.FACEBOOK_ADS_OBJECT_PICKER_FIELDS_LOAD_START, function () {
            $scope.schemaReady = false;
            $scope.schemaMappingStep.loading = true;
            $scope.schemaMappingStep.lock = false;
            $scope.areFieldsLoading = true;
          });

          $scope.$on(EVENTS.FACEBOOK_ADS_OBJECT_PICKER_FIELDS_LOADED, function (event, fields) {
            const destinationSchema = {};

            destinationSchema.id = 'facebook_ads_fields';
            destinationSchema.name = 'facebook_ads_fields';
            destinationSchema.fields = [];

            _.each(fields, function (field) {
              destinationSchema.fields.push({
                name: field.name,
              });
            });

            const schemas = [$scope.parentSchemas[0], destinationSchema];

            $scope.schemas = schemas;
            $scope.fields = fields;

            $scope.schemaReady = true;
            $scope.schemaMappingStep.lock = false;
            $scope.schemaMappingStep.loading = false;

            $scope.areFieldsLoading = false;
          });
        },
      ],
    };
  },
]);
